import { imgUrl } from "../../../../api/api";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addContent, deleteContent } from "../../../../Redux/Actions/formAction";
import "./video.css";
function Video(props) {
  const { allContent } = useSelector((state) => state.Form);
  const dispatch = useDispatch();
  const checkBox = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      dispatch(
        addContent(
          props.pId,
          allContent.find((c) => c.id === value)
        )
      );
    } else {
      dispatch(deleteContent(props.pId, value));
    }
  };
  return (
    <>
      <div className="image-container">
        {allContent.map(
          (data) =>
            data.type === "video" && (
              <>
                <div className="image-content-cards" key={data.id}>
                <div style={{margin:'0 10px'}}>
                 <input
                    type="checkbox"
                    name={data.name}
                    value={data.id}
                    checked={data.selected}
                    onChange={checkBox}
                    id={`checkbox${data.id}`}
                    style={{height:'15px',width:'15px'}}
                    hidden
                  />
                 </div>
                  <label htmlFor={`checkbox${data.id}`} className="full-container">
                    <div className="image-content-card-image check-tick">
                      <video src={`${data.url}`} controls />
                    </div>
                    <div className="image-content-card-footer">
                      <p>{data.name.substring(0,20)}</p>
                    </div>
                  </label>
                </div>
              </>
            )
        )}
      </div>
    </>
  );
}

export default Video;
